// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Training/training.scss
// module id = 586
// module chunks = 0